<template>
  <FormSubmitPopup
    :title="$t('createAudit')"
    v-model="value"
    @popupClose="$emit('input', false)"
    :rightMethod="onSubmitted"
    :rightButtonText="$t('submit')"
    hasAlert
    medium
  >
    <template v-slot:input>
      <v-container>
        <v-layout>
          <v-flex xs6>
            <v-autocomplete
              :items="warehousesSites"
              item-text="siteName"
              item-value="key"
              v-model="siteKey"
              :rules="[fieldIsRequired()]"
              :label="$t('warehouseSite')"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-textarea
              :label="$t('note')"
              v-model="note"
              outline
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-container>
    </template>
  </FormSubmitPopup>
</template> 

<script>
import FormSubmitPopup from './FormSubmitPopup'
import { checkRules } from '@/utils/tools'

export default {
  name: 'WarehouseAuditCreatePopup',
  components: {
    FormSubmitPopup
  },
  mixins: [checkRules],
  data () {
    return {
      note: '',
      siteKey: window.localStorage.getItem('defaultSite' + this.$store.getters.uid)
    }
  },
  computed: {
    warehousesSites () {
      return this.$store.getters.warehousesSites
    }
  },
  watch: {
    
  },
  methods: {
    async onSubmitted () {
      const audit = await this.$store.dispatch('createAudit', this.$data)
      this.$emit('onSubmitted', {
        ...audit,
        createTime: new Date()
      })
    }
  },
  props: {
    value: Boolean
  }
}
</script>



// WEBPACK FOOTER //
// src/components/WarehouseAuditCreatePopup.vue